import { useEffect, useState } from 'react';

export function useFetch(request) {
  const requestArgs = Array.prototype.slice.call(arguments, 1);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const abortController = new AbortController();
    setIsLoading(true);
    (async () => {
      try {
        const response = await request.apply(null, requestArgs);
        setResponse(response);
        setIsLoading(false);
      } catch (error) {
        if (isAbortError(error)) {
          return;
        }
        setError(error);
        setIsLoading(false);
      }
    })();
    return () => {
      abortController.abort();
    };
  }, [JSON.stringify(requestArgs)]);

  return { response, error, isLoading };
}

// type guards
function isAbortError(error) {
  if (error && error.name === 'AbortError') {
    return true;
  }
  return false;
}
